import { UsuarioService } from "../rest"

const Acceso = {
    activarModulo: (modulo) => {
        return modulo && UsuarioService.getUsuario().modulos
            ? UsuarioService.getUsuario().modulos.includes(modulo)
            : false
    },
    activarOpcion: (opcId) => {
        return opcId && UsuarioService.getUsuario().opciones
            ? UsuarioService.getUsuario().opciones.includes(opcId)
            : false
    },
}

export default Acceso